import { readItems } from "@directus/sdk";
import { directus } from "./FetchDirectus";
import { useNavigate } from "react-router-dom";
class Collection {
  static readCollection = async (collection: string) => {
    const navigate = useNavigate();
    try {
      const list = await directus.request(readItems(collection, { limit: -1 }));
      return [...list];
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return;
    }
  };
}

export default Collection;
